export type ApiEventName = 'sessionExpired' | 'tooManyRequests' | 'offline';

const target = new EventTarget();
const lastEmitted: Partial<Record<ApiEventName, number>> = {};
const THROTTLE_MS = 5000;

/** Tells the UI about a failed API call (RTK Query lives outside React); the same event is sent at most once per 5 seconds. */
export const emitApiEvent = (name: ApiEventName) => {
  const now = Date.now();
  if (now - (lastEmitted[name] ?? 0) < THROTTLE_MS) return;
  lastEmitted[name] = now;
  target.dispatchEvent(new Event(name));
};

export const onApiEvent = (name: ApiEventName, listener: () => void) => {
  target.addEventListener(name, listener);
  return () => {
    target.removeEventListener(name, listener);
  };
};
